import type { MindMapNode, EdgeData, ExpandedMap } from "./types";

export function collectEdges(
  node: MindMapNode,
  expanded: ExpandedMap
): EdgeData[] {
  const edges: EdgeData[] = [];

  if (!node.children || !expanded[node.id]) return edges;

  for (const child of node.children) {
    edges.push({
      id: `${node.id}-${child.id}`,
      from: node.id,
      to: child.id,
    });
    edges.push(...collectEdges(child, expanded));
  }

  return edges;
}
